import React, { useEffect, useState } from "react";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  MenuItem,
  TextField,
  Typography
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import axios from "axios";
import api from "../api";
import { Autocomplete } from "@material-ui/lab";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InfoAuto from "../../vehicles/InfoAuto/InfoAuto";
import { Info } from "@material-ui/icons";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const InfoAutoDialog = ({ version, model }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Typography
        variant="button"
        className="mt-2 ml-2"
        onClick={() => setOpen(!open)}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          display: "inline-block",
          fontSize: "12px"
        }}
      >
        Ficha InfoAuto{" "}
      </Typography>
      <Dialog
        PaperProps={{
          style: {
            width: "900px",
            maxWidth: "900px"
          }
        }}
        open={open}
        fullWidth
        aria-labelledby="responsive-dialog-title"
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          {"Ficha InfoAuto"}
        </DialogTitle>
        <DialogContent style={{ width: "900px" }}>
          <InfoAuto variation={model} version={version} />
        </DialogContent>
      </Dialog>
    </>
  );
};

const bookingQuoteTypes = [
  {
    id: 1,
    name: "Flex"
  },
  {
    id: 2,
    name: "Renting"
  }
];
const Quote = ({ id }) => {
  const [bookingQuote, setBookingQuote] = useState({ id: 0 });
  const [plateBooking, setPlateBooking] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    severity: "success"
  });
  const [versions, setVersions] = useState({
    options: [],
    loading: false
  });
  const [clients, setClients] = useState({
    options: [],
    loading: false
  });
  const [vehicles, setVehicles] = useState({
    options: [],
    loading: false
  });
  const [subcontacts, setSubcotacts] = useState([]);

  useEffect(() => {
    if (id) {
      getQuote(id);
    }
  }, [id]);

  const getVersion = async id => {
    const token = localStorage.getItem("userToken");
    if (id > 0) {
      axios
        .get(api.versions().get(id), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          if (res.data && res.data[0]) {
            const version = res.data[0].versions.filter(v => v.id == id);
            if (version.length > 0) {
              const r = version[0];
              // unset versions in res.data[0]
              delete res.data[0].versions;
              r.variation = res.data[0];
              setSelectedVersion(r);
            }
          }
        });
    }
  };
  const getQuote = async id => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.bookings().quote(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setBookingQuote(res.data);
        setPlateBooking(true);
      })
      .catch(err => {
        console.log(err);
      });
  };
  const handleSearchVersions = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      return axios
        .get(api.versions().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setVersions({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  const handleClientSearch = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      return axios
        .get(api.clients().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setClients({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  const handleVehicleSearch = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      return axios
        .get(api.vehicles().indexAc(1, value), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setVehicles({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const handleExport = async () => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.bookings().exportQuote(bookingQuote.id), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob"
      })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          "Cotizacion_Renting_" + bookingQuote.id + ".pdf"
        ); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  const handleSubmit = async (transition = null) => {
    setSaving(true);
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append(
      "booking_quote[type]",
      bookingQuote.type ? bookingQuote.type : ""
    );
    formData.append(
      "booking_quote[external_code]",
      bookingQuote.external_code ? bookingQuote.external_code : ""
    );
    formData.append(
      "booking_quote[client_id]",
      bookingQuote.client_id ? bookingQuote.client_id : ""
    );
    formData.append(
      "booking_quote[subcontact_id]",
      bookingQuote.subcontact_id ? bookingQuote.subcontact_id : ""
    );
    if (plateBooking) {
      formData.append(
        "booking_quote[vehicle_id]",
        bookingQuote.vehicle_id ? bookingQuote.vehicle_id : ""
      );
    } else {
      formData.append(
        "booking_quote[version_id]",
        bookingQuote.version_id ? bookingQuote.version_id : ""
      );
    }
    formData.append(
      "booking_quote[description]",
      bookingQuote.description ? bookingQuote.description : ""
    );
    formData.append(
      "booking_quote[start_date]",
      bookingQuote.start_date ? bookingQuote.start_date : ""
    );
    formData.append(
      "booking_quote[end_date]",
      bookingQuote.end_date ? bookingQuote.end_date : ""
    );
    formData.append(
      "booking_quote[due_date]",
      bookingQuote.due_date ? bookingQuote.due_date : ""
    );
    formData.append(
      "booking_quote[unit_price]",
      bookingQuote.unit_price ? bookingQuote.unit_price : ""
    );
    formData.append(
      "booking_quote[q_units]",
      bookingQuote.q_units ? bookingQuote.q_units : ""
    );
    formData.append(
      "booking_quote[km_price]",
      bookingQuote.km_price ? bookingQuote.km_price : ""
    );
    formData.append(
      "booking_quote[q_km_included]",
      bookingQuote.q_km_included ? bookingQuote.q_km_included : ""
    );
    formData.append(
      "booking_quote[extra_km_price]",
      bookingQuote.extra_km_price ? bookingQuote.extra_km_price : ""
    );
    formData.append(
      "booking_quote[extras_comments]",
      bookingQuote.extras_comments ? bookingQuote.extras_comments : ""
    );
    formData.append(
      "booking_quote[extras_price]",
      bookingQuote.extras_price ? bookingQuote.extras_price : ""
    );
    formData.append(
      "booking_quote[franchise]",
      bookingQuote.franchise ? bookingQuote.franchise : ""
    );
    formData.append(
      "booking_quote[client_requirements]",
      bookingQuote.client_requirements ? bookingQuote.client_requirements : ""
    );
    formData.append(
      "booking_quote[comments]",
      bookingQuote.comments ? bookingQuote.comments : ""
    );
    if (transition) formData.append("transition", transition);

    if (id > 0) {
      formData.append("_method", "PATCH");
      await axios
        .post(api.bookings().quote(id), formData, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setSaving(false);
          setSnackbar({
            open: true,
            message: "Cotización guardada correctamente",
            severity: "success"
          });
          getQuote(id);
        })
        .catch(err => {
          console.log(err);
          setSnackbar({
            open: true,
            message: "Ha ocurrido un error al guardar la cotización",
            severity: "error"
          });
        });
    } else {
      return axios
        .post(api.bookings().storeQuote(), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })

        .then(res => {
          setSaving(false);
          const { data } = res;
          const { booking_quote } = data;
          window.location.href = `/bookings/quote/${booking_quote.id}`;
        })
        .catch(err => {
          const { errors } = err.response.data;
          let error_msg = "";
          if (errors) {
            for (let key in errors) {
              error_msg += errors[key];
            }
            setSnackbar({
              open: true,
              message: error_msg,
              severity: "error"
            });
          } else {
            setSnackbar({
              open: true,
              message: "Ha ocurrido un error al crear la relación",
              severity: "error"
            });
          }
        });
    }
  };

  const handleCreateBooking = async () => {
    setSaving(true);
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("id", bookingQuote.id);
    return axios
      .post(api.bookings().storeBooking(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })

      .then(res => {
        setSaving(false);
        const { data } = res;
        window.location.href = `/booking/${data.id}`;
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        className="alert-fix"
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className="row">
        <div className="col-md-12">
          <Typography variant="h6" className="mr-2 mt-1">
            Datos de la cotización{" "}
            {bookingQuote && bookingQuote.id > 0
              ? bookingQuote.id + " - (" + bookingQuote.state + ")"
              : ""}
            {bookingQuote.id > 0 && (
              <Button
                variant="text"
                color="default"
                className="ml-2"
                style={{ fontSize: "0.7rem" }}
                onClick={() => {
                  handleExport();
                }}
              >
                Exportar PDF
              </Button>
            )}
          </Typography>
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">
          <TextField
            id="type"
            name="type"
            select
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                type: e.target.value
              });
            }}
            value={bookingQuote.type}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Tipo de Reserva</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          >
            {bookingQuoteTypes.map(option => (
              <MenuItem
                key={option.id}
                value={option.id}
                style={{ fontSize: "0.75rem" }}
              >
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="col-md-2">
          <TextField
            id="external_code"
            name="external_code"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                external_code: e.target.value
              });
            }}
            type="text"
            value={bookingQuote.external_code}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Codigo Externo</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        <div className="col-md-3">
          {bookingQuote.id == 0 ? (
            <Autocomplete
              id={"clients"}
              name={"clients"}
              getOptionLabel={option => option.business_name}
              getOptionSelected={(option, value) =>
                option.business_name === value
              }
              renderOption={option => (
                <Typography variant="caption">
                  {option.business_name}
                </Typography>
              )}
              options={clients.options}
              loading={clients.loading}
              onInputChange={handleClientSearch}
              onChange={(e, value) => {
                if (value) {
                  setBookingQuote({
                    ...bookingQuote,
                    client_id: value.id
                  });
                  if (
                    value.contact &&
                    value.contact.subcontacts &&
                    value.contact.subcontacts.length > 0
                  ) {
                    setSubcotacts(value.contact.subcontacts);
                  }
                }
              }}
              autoComplete
              noOptionsText={
                <Typography variant="caption">Sin resultados</Typography>
              }
              includeInputInList
              className="mt-2 mr-2"
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder="Ingrese un cliente"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {versions.loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    shrink: true
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "0.75rem", width: 230 }
                  }}
                />
              )}
            />
          ) : (
            <TextField
              disabled
              id="client_id"
              name="client_id"
              value={
                bookingQuote && bookingQuote.client
                  ? bookingQuote.client.business_name
                  : ""
              }
              margin="normal"
              className="mr-2 mt-1"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Cliente</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          )}
        </div>
        {subcontacts && subcontacts.length > 0 && (
          <div className="col-md-3">
            <TextField
              id="subcontact_id"
              name="subcontact_id"
              select
              margin="normal"
              className="mr-2 mt-1"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBookingQuote({
                  ...bookingQuote,
                  subcontact_id: e.target.value
                });
              }}
              value={bookingQuote.subcontact_id}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Contacto</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            >
              {subcontacts.map(option => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option.firstname} {option.lastname}
                </MenuItem>
              ))}
            </TextField>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-md-3">
          {!plateBooking ? (
            <Autocomplete
              id={"versions"}
              name={"versions"}
              getOptionLabel={option => option.full_name}
              getOptionSelected={(option, value) => option.full_name === value}
              options={versions.options}
              loading={versions.loading}
              onInputChange={handleSearchVersions}
              renderOption={option => (
                <Typography variant="caption">
                  {option.full_name} {option.vehicle_type ? " - " : ""}
                  {option.vehicle_type
                    ? option.vehicle_type.hansa_code
                    : ""}{" "}
                  {option.vehicle_type
                    ? option.vehicle_type.hansa_description
                    : ""}{" "}
                </Typography>
              )}
              onChange={(e, value) => {
                if (value) {
                  setBookingQuote({
                    ...bookingQuote,
                    version_id: value.id
                  });
                  getVersion(value.id);
                }
              }}
              noOptionsText={
                <Typography variant="caption">
                  {versions.loading ? "Buscando" : "Sin resultados"}
                </Typography>
              }
              includeInputInList
              className="mt-2 mr-2"
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder="Ingrese una version"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {versions.loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    shrink: true
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "0.75rem", width: 230 }
                  }}
                />
              )}
            />
          ) : (
            <Autocomplete
              id={"vehicles"}
              name={"vehicles"}
              getOptionLabel={option => option.plate}
              getOptionSelected={(option, value) => option.plate === value}
              options={vehicles.options}
              loading={vehicles.loading}
              onInputChange={handleVehicleSearch}
              renderOption={option => (
                <Typography variant="caption">
                  {option.plate} {option.description}
                  {option.version.vehicle_type
                    ? "(" +
                      option.version.vehicle_type.hansa_description +
                      " - " +
                      option.version.vehicle_type.hansa_code +
                      ")"
                    : ""}
                </Typography>
              )}
              onChange={(e, value) => {
                if (value) {
                  setBookingQuote({
                    ...bookingQuote,
                    vehicle_id: value.id
                  });
                }
              }}
              autoComplete
              noOptionsText={
                <Typography variant="caption">Sin resultados</Typography>
              }
              includeInputInList
              className="mt-2 mr-2"
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder={`Ingrese una patente`}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {versions.loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    shrink: true
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "0.75rem", width: 230 }
                  }}
                />
              )}
            />
          )}
        </div>
        {bookingQuote.id == 0 ? (
          <></>
        ) : (
          <div className="col-md-3">
            <TextField
              disabled
              id="vehicle_id"
              name="vehicle_id"
              value={
                bookingQuote && bookingQuote.vehicle
                  ? bookingQuote.vehicle.plate
                  : bookingQuote && bookingQuote.version
                  ? bookingQuote.version.full_name
                  : ""
              }
              margin="normal"
              className="mr-2 mt-1"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      {bookingQuote.vehicle ? "Vehículo" : "Version"}
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </div>
        )}
        {bookingQuote.id == 0 && (
          <div className="col-md-2">
            <Button
              variant="outlined"
              color="primary"
              className="mt-2"
              style={{ fontSize: "0.58rem" }}
              onClick={() => setPlateBooking(!plateBooking)}
            >
              {plateBooking && bookingQuote.id == 0
                ? "Buscar por version"
                : "Buscar por patente"}
            </Button>
          </div>
        )}
        {selectedVersion &&
          selectedVersion.infoauto_codia &&
          selectedVersion.variation && (
            <InfoAutoDialog
              version={selectedVersion}
              model={selectedVersion.variation}
            />
          )}
        <div className="col-md-12">
          <FormControl
            required
            inputProps={{ shrink: true }}
            style={{ width: "100%" }}
          >
            <Typography variant="caption" style={{ color: "#000" }}>
              Descripción
            </Typography>
            <ReactQuill
              theme="snow"
              style={{ width: "100%", backgroundColor: "#fff" }}
              className="my-2"
              value={bookingQuote.description ? bookingQuote.description : ""}
              onChange={content => {
                setBookingQuote({
                  ...bookingQuote,
                  description: content
                });
              }}
            />
          </FormControl>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Typography variant="h6" className="mr-2 mt-1">
            Detalle
          </Typography>
        </div>
        <div className="col-md-3">
          <TextField
            id="start_date"
            name="start_date"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                start_date: e.target.value
              });
            }}
            type="datetime-local"
            value={bookingQuote.start_date}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Fecha inicio</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <TextField
            id="end_date"
            name="end_date"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                end_date: e.target.value
              });
            }}
            type="datetime-local"
            value={bookingQuote.end_date}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Fecha fin</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <TextField
            id="due_date"
            name="due_date"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                due_date: e.target.value
              });
            }}
            type="datetime-local"
            value={bookingQuote.due_date}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Fecha vencimiento</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <NumberFormat
            id="unit_price"
            name="unit_price"
            value={bookingQuote.unit_price}
            onValueChange={values => {
              const { value } = values;
              setBookingQuote({
                ...bookingQuote,
                unit_price: value
              });
            }}
            className="mr-2 mt-1"
            InputProps={{
              style: { fontSize: "0.75rem" },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Precio unitario</Typography>
                </InputAdornment>
              )
            }}
            thousandSeparator="."
            decimalSeparator=","
            prefix={"$"}
            customInput={TextField}
            InputLabelProps={{
              shrink: true
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <TextField
            id="q_units"
            name="q_units"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                q_units: e.target.value
              });
            }}
            type="integer"
            value={bookingQuote.q_units}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Cantidad unidades</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <NumberFormat
            id="km_price"
            name="km_price"
            value={bookingQuote.km_price}
            onValueChange={values => {
              const { value } = values;
              setBookingQuote({
                ...bookingQuote,
                km_price: value
              });
            }}
            className="mr-2 mt-1"
            InputProps={{
              style: { fontSize: "0.75rem" },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Precio km</Typography>
                </InputAdornment>
              )
            }}
            thousandSeparator="."
            decimalSeparator=","
            prefix={"$"}
            customInput={TextField}
            InputLabelProps={{
              shrink: true
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <TextField
            id="q_km_included"
            name="q_km_included"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                q_km_included: e.target.value
              });
            }}
            type="integer"
            value={bookingQuote.q_km_included}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">
                    Cantidad km incluidos
                  </Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <NumberFormat
            id="extra_km_price"
            name="extra_km_price"
            value={bookingQuote.extra_km_price}
            onValueChange={values => {
              const { value } = values;
              setBookingQuote({
                ...bookingQuote,
                extra_km_price: value
              });
            }}
            className="mr-2 mt-1"
            InputProps={{
              style: { fontSize: "0.75rem" },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Precio km extra</Typography>
                </InputAdornment>
              )
            }}
            thousandSeparator="."
            decimalSeparator=","
            prefix={"$"}
            customInput={TextField}
            InputLabelProps={{
              shrink: true
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <TextField
            id="extras_comments"
            name="extras_comments"
            onChange={e => {
              setBookingQuote({
                ...bookingQuote,
                extras_comments: e.target.value
              });
            }}
            type="text"
            value={bookingQuote.extras_comments}
            margin="normal"
            className="mr-2 mt-1"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Extras incluidos</Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <NumberFormat
            id="extras_price"
            name="extras_price"
            value={bookingQuote.extras_price}
            onValueChange={values => {
              const { value } = values;
              setBookingQuote({
                ...bookingQuote,
                extras_price: value
              });
            }}
            className="mr-2"
            InputProps={{
              style: { fontSize: "0.75rem" },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Precio Extras</Typography>
                </InputAdornment>
              )
            }}
            thousandSeparator="."
            decimalSeparator=","
            prefix={"$"}
            customInput={TextField}
            InputLabelProps={{
              shrink: true
            }}
          />{" "}
        </div>
        <div className="col-md-3">
          <NumberFormat
            id="franchise"
            name="franchise"
            value={bookingQuote.franchise}
            onValueChange={values => {
              const { value } = values;
              setBookingQuote({
                ...bookingQuote,
                franchise: value
              });
            }}
            className="mr-2"
            InputProps={{
              style: { fontSize: "0.75rem" },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Franquicia</Typography>
                </InputAdornment>
              )
            }}
            thousandSeparator="."
            decimalSeparator=","
            prefix={"$"}
            customInput={TextField}
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div className="col-md-12 mt-2">
          <FormControl
            required
            inputProps={{ shrink: true }}
            style={{ width: "100%" }}
          >
            <Typography variant="caption" style={{ color: "#000" }}>
              Requerimientos del cliente
            </Typography>
            <ReactQuill
              style={{ width: "100%", backgroundColor: "#fff" }}
              className="my-2"
              value={
                bookingQuote.client_requirements
                  ? bookingQuote.client_requirements
                  : ""
              }
              onChange={content => {
                setBookingQuote({
                  ...bookingQuote,
                  client_requirements: content
                });
              }}
            />
          </FormControl>
        </div>
        <div className="col-md-12 mt-2">
          <TextareaAutosize
            id="comments"
            name="comments"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption" style={{ minWidth: 50 }}>
                    Comentarios
                  </Typography>
                </InputAdornment>
              )
            }}
            minRows={5}
            placeholder="Agregue comentarios"
            className="mr-2 mt-0"
            InputLabelProps={{
              shrink: true
            }}
            onChange={value =>
              setBookingQuote({
                ...bookingQuote,
                comments: value.target.value
              })
            }
            value={bookingQuote.comments}
            style={{ width: "100%", fontSize: "0.75rem" }}
          />
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-12">
          {bookingQuote.state == "cerrada" && (
            <Button
              variant="contained"
              color="green"
              className="mt-2 ml-2"
              onClick={() => {
                handleCreateBooking();
              }}
            >
              Crear Reserva
            </Button>
          )}
          {bookingQuote.state != "cerrada" &&
            bookingQuote.state != "cancelada" && (
              <Button
                variant="contained"
                color="primary"
                className="mt-2"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Guardar
              </Button>
            )}

          {bookingQuote.transitions &&
            bookingQuote.transitions.map(transition => {
              return (
                <Button
                  key={transition.id}
                  variant="contained"
                  color="primary"
                  className="mt-2 ml-2"
                  onClick={() => {
                    handleSubmit(transition.state);
                  }}
                >
                  {transition.transition[0]}
                </Button>
              );
            })}

          <Button
            variant="contained"
            color="secondary"
            className="mt-2 ml-2"
            onClick={() => {
              window.history.back();
            }}
          >
            Volver
          </Button>
        </div>
      </div>
    </>
  );
};

export default Quote;
